export const heroImage =
  'https://cdn.magicpatterns.com/uploads/x6vEXYuNT7tov6wRxuzXJX/Gemini_Generated_Image_t9wct7t9wct7t9wc.jpg'

export const stats = [
  {
    value: '+500',
    label: 'Terapeutas y facilitadores capaces',
  },
  {
    value: '8 Etapas',
    label: 'Protocolo claro de principio a fin',
  },
  {
    value: '+1.200',
    label: 'Horas de consulta e impase ahorradas',
  },
  {
    value: '99%',
    label: 'Recomendado por profesionales holísticos',
  },
]

export const promiseItems = [
  {
    title: '3 Tomos en 1 especializados',
    detail: 'Fundamentos, dimensión espiritual e interferencias.',
  },
  {
    title: '100% digital',
    detail: 'Acceso e instalación inmediata.',
  },
  {
    title: '3 bonos de protocolo',
    detail: 'Herramientas prácticas para el consultorio.',
  },
]

export const antes = [
  'Horas perdidas buscando información dispersa, contradictoria o poco clara sobre regresión.',
  'Ansia e inseguridad: miedo a “hacer algo mal”, estancarte en el trance o no saber cómo cerrar una sesión compleja.',
  'Fricción al abordar interferencias o bloqueos energéticos por falta de una taxonomía clara.',
  'Dificultad para evaluar la sugestionabilidad del consultante y adaptar el ritmo adecuadamente.',
]

export const despues = [
  '5 minutos de revisión y estarás listo para iniciar la regresión con serenidad y autoridad.',
  'Protocolo fluido en 8 etapas con guiones de inducción y des-inducción listos para usar.',
  'Criterios y checklist de seguridad para mantener un encuadre responsable y ético.',
  'Manejo de interferencias: método en 5 pasos para discernir, limpiar y liberar con efectividad.',
  'Un sistema integral para estructurar menos tu mente y conectar más con la sanación de tu consultante.',
]

export type StackItem = {
  icon: 'book' | 'spiral' | 'compass' | 'shield' | 'notebook'
  title: string
  detail: string
}

export const stack: StackItem[] = [
  {
    icon: 'book',
    title: 'Material digital de más de 90 páginas de profundización',
    detail:
      'Fundamentos teóricos, dimensión espiritual y vidas pasadas, y taxonomía avanzada de interferencias.',
  },
  {
    icon: 'spiral',
    title: 'Guiones de inducción y des-inducción «listos para aplicar»',
    detail:
      'Plantillas con ritmo, tono y pausas exactas para guiar el trance de forma estable.',
  },
  {
    icon: 'compass',
    title: 'Protocolo de discernimiento en 5 pasos',
    detail:
      'Evaluación precisa para identificar la raíz de los bloqueos sin sesgos ni imposiciones.',
  },
  {
    icon: 'shield',
    title: 'Checklist de seguridad e higiene energética',
    detail:
      'Protocolos de contención y límites éticos responsables, pre y post sesión.',
  },
  {
    icon: 'notebook',
    title: 'Bitácora de sesión y registro de hallazgos',
    detail:
      'Formato clínico descargable para registrar respuestas, símbolos y evolución del paciente.',
  },
]

export const carousel = [
  {
    tag: 'Tomo I · Fundamentos',
    title: 'Estructura de la sesión en 8 etapas',
    detail:
      'Paso a paso exacto desde la entrevista inicial hasta la reintegración consciente, con indicaciones de voz y manejo del tiempo.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e9f1b3a5-2268-411e-b4aa-ed778137cb43.jpg',
  },
  {
    tag: 'Tomo I · Preparación',
    title: 'Evaluación de sugestionabilidad y respiración prana',
    detail:
      'Ejercicios progresivos para profundizar el nivel de trance de forma estable y segura antes de iniciar la regresión.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/771fb19c-dde6-46e5-a775-b787c30865cb.jpg',
  },
  {
    tag: 'Tomo II · Dimensión espiritual',
    title: 'Regresión a vidas pasadas y espacio entre vidas',
    detail:
      'Preguntas clave para el rastreo de memorias del alma, lazos emocionales y recuperación de aprendizajes conscientes.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d9b4ff05-3b31-4883-8f03-5571198a38b5.jpg',
  },
  {
    tag: 'Tomo III · Discernimiento',
    title: 'Taxonomía y manejo de interferencias',
    detail:
      'Guía clínica para reconocer señales, diferenciar sugestión de interferencia real y aplicar la secuencia de liberación.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/fd02c0f3-5b66-4003-b7ba-f4fe2f796df1.jpg',
  },
  {
    tag: 'Herramienta práctica · Registro',
    title: 'Bitácora de trabajo terapéutico',
    detail:
      'Plantilla para registrar emociones, mensajes clave y patrones emergentes durante cada etapa de la consulta.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f560a8cc-3684-4108-8c03-99463aab0bb2.jpg',
  },
]

export const bonuses = [
  {
    number: 'Bono #1',
    title: 'Bitácora de sesión y registro de hallazgos',
    detail:
      'El sistema rápido para registrar trance, emociones, señales e interpretaciones sin perder el hilo de la consulta.',
    price: 'AR$ 14.990',
  },
  {
    number: 'Bono #2',
    title: 'Guiones de inducción y des-inducción rápidos',
    detail:
      'Plantillas de voz listas para usar con indicaciones de ritmo, tono y variaciones según la receptividad del paciente.',
    price: 'AR$ 9.990',
  },
  {
    number: 'Bono #3',
    title: 'Checklist de seguridad y límites responsables',
    detail:
      'Lista de verificación esencial para higiene energética, evaluación previa y contención ética antes de cada regresión.',
    price: 'AR$ 7.990',
  },
]

export const testimonials = [
  {
    quote:
      'Recuperé la tranquilidad en consulta. Antes me daba miedo no saber cómo actuar ante una interferencia; hoy el protocolo en 8 etapas me guía con absoluta claridad.',
    name: 'María G.',
    role: 'Terapeuta Holística',
  },
  {
    quote:
      'Material de un nivel técnico y ético altísimo. Los guiones de inducción y las tablas de discernimiento simplificaron mis sesiones desde el primer día.',
    name: 'Carlos R.',
    role: 'Hipnoterapeuta',
  },
  {
    quote:
      'Es el mapa definitivo para trabajar regresiones sin caer en desorden ni sesgos. El mejor recurso profesional que he adquirido.',
    name: 'Elena M.',
    role: 'Psicoterapeuta y Transpersonal',
  },
]

export const faqs = [
  {
    question: '¿Este material es para principiantes o necesito experiencia previa?',
    answer:
      'Está estructurado de forma progresiva. Si eres principiante, te dará el mapa paso a paso para no cometer errores. Si ya eres terapeuta, te servirá para ordenar tu metodología, perfeccionar inducciones y resolver casos complejos.',
  },
  {
    question: '¿Es una formación teórica o incluye herramientas aplicables?',
    answer:
      'Es un sistema 100% práctico y aplicable. Además de las bases teóricas y espirituales, obtendrás guiones exactos, listas de cotejo, ejercicios de respiración y prana, y el paso a paso del protocolo de sesión.',
  },
  {
    question: '¿Cómo aborda el tema de la seguridad y el discernimiento?',
    answer:
      'Cuenta con un tomo especializado y una checklist de seguridad enfocados en la ética terapéutica, manejo de expectativas, higiene energética y criterios en 5 pasos para no sugestionar al paciente.',
  },
  {
    question: '¿Cómo recibo el material tras la compra?',
    answer:
      'Al completar tu pago, recibirás un correo electrónico con acceso inmediato para descargar todos los tomos y bonos digitales en tu computadora, tablet o teléfono.',
  },
  {
    question: '¿Hay costos mensuales o suscripciones?',
    answer:
      'No. Haces un pago único y el material es tuyo para siempre, incluyendo el acceso a futuras revisiones.',
  },
]
